module.exports = __webpack_public_path__ + "img/leo.7952199e.svg";